import { customizeConfig } from "PFCore/initializers/customize_config";

export const applyUrlConfig = (): boolean => {
  const currentUrl = new URL(window.location.href);
  const { searchParams } = currentUrl;

  const apiEndpoint = searchParams.get("api_endpoint")?.replace(/\/$/, "");
  const developmentDomain = searchParams.get("development_domain");

  if (!apiEndpoint || !developmentDomain) {
    return false;
  }

  const { api_endpoint: currentApiEndpoint, development_domain: currentDevelopmentDomain } = window.PF.config;

  if (apiEndpoint === currentApiEndpoint && developmentDomain === currentDevelopmentDomain) {
    return false;
  }

  customizeConfig({ api_endpoint: apiEndpoint, development_domain: developmentDomain });

  searchParams.delete("api_endpoint");
  searchParams.delete("development_domain");

  window.location.replace(currentUrl.toString());

  return true;
};
